





































































































































































import Vue from "vue";
import { axios } from "../../../plugins";
import { CreateAppData } from "../transform";
export default Vue.extend({
  name: "GrayInfo",
  props: {
    data: { type: Object },
    projectId: { type: String }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      grayData: null as any,
      comData: (null as any) as CreateAppData,
      // grayData 修改标记
      grayDataChanged: false,
      comDataChanged: false
    };
  },
  mounted() {
    const app = document.querySelector("#prj-app");
    if (app) {
      app.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    const app = document.querySelector("#prj-app");
    if (app) {
      app.removeChild(this.$el);
    }
  },
  methods: {
    show(data: any) {
      this.getComData(data);
    },
    getComData(data: any) {
      axios
        .get(
          `/${(this.data.kind as string).toLowerCase()}/${this.projectId}/${
            data.spec.http[0].route[1].destination.subset
          }`
        )
        .then(res => {
          this.grayData = data;
          this.comData = res.data.data;
          this.dialog = true;
        });
    },
    weightChange(value: number, index: number) {
      this.grayDataChanged = true;
      this.grayData.spec.http[0].route[(index + 1) % 2].weight = 100 - value;
      if (this.grayData.type === "EXTERNAL") {
        this.grayData.weight = index === 1 ? value : 100 - value;
      }
    },
    handleCommand(type: string, index: number) {
      switch (type) {
        case "weight":
          this.grayDataChanged = true;
          this.grayData.spec.http[0].route[(index + 1) % 2].weight = 0;
          this.grayData.spec.http[0].route[index].weight = 100;
          if (this.grayData.type === "EXTERNAL") {
            this.grayData.weight = index === 1 ? 100 : 0;
          }
          break;

        default:
          break;
      }
    },
    quit() {
      this.grayData = null;
      this.grayDataChanged = false;
      this.comDataChanged = false;
      this.comData = (null as any) as CreateAppData;

      this.dialog = false;
    },
    submit() {
      if (!this.grayDataChanged) return;
      this.loading = true;
      if (this.grayData.type === "EXTERNAL") {
        axios
          .put(
            `/grayrelease/ingress/${this.projectId}/release/${this.grayData.id}`,
            this.grayData
          )
          .then(() => {
            this.$message.success("灰度发布任务已更新");
            this.$emit("refush");
            this.quit();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        axios
          .put(
            `/grayrelease/${this.projectId}/release/${this.grayData.id}`,
            this.grayData
          )
          .then(() => {
            this.$message.success("灰度发布任务已更新");
            this.$emit("refush");
            this.quit();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    deleteGray() {
      this.loading = true;
      if (this.grayData.type === "EXTERNAL") {
        axios
          .delete(
            `/grayrelease/ingress/${this.projectId}/release/${this.grayData.id}`
          )
          .then(() => {
            this.$message.success("灰度发布任务已下线");
            this.$emit("refush");
            this.quit();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        axios
          .delete(`/grayrelease/${this.projectId}/release/${this.grayData.id}`)
          .then(() => {
            this.$message.success("灰度发布任务已下线");
            this.$emit("refush");
            this.quit();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
